import axios from '@/lib/axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface DeleteAddressParams {
  addressId: string;
}

const deleteUserDeleteAddressMutation = async ({
  addressId,
}: DeleteAddressParams) => {
  const response = await axios.delete(`/user/delete_address/${addressId}/`);
  return response;
};

export const useDeleteUserDeleteAddressMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['delete-user-address'],
    mutationFn: deleteUserDeleteAddressMutation,
    onSuccess: () => {
      // Address book reads from ['user', 'details', userid]; prefix-match
      // invalidates all user-detail caches since userid is not available here.
      void queryClient.invalidateQueries({
        queryKey: ['user', 'details'],
        exact: false,
      });
    },
  });
};
